import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { PropertyDetailsComponent } from './pages/property-details/property-details.component';
import { PropertySuggestionsComponent } from './pages/property-suggestions/property-suggestions.component';
import { ContactDetailsComponent } from './pages/contact-details/contact-details.component';

const routes: Routes = [
  { path: 'home', component: LandingPageComponent },
  { path: 'property-details', component: PropertyDetailsComponent },
  { path: 'property-suggestions', component: PropertySuggestionsComponent },
  { path: 'contact-details', component: ContactDetailsComponent },
  { path: '**', component: LandingPageComponent }, 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
